enum Role {
  GUEST = 'guest',
  OWNER = 'owner',
  ADMIN = 'admin',
  MEMBER = 'member',
}
export default Role;
